import { render, staticRenderFns } from "./announceList.vue?vue&type=template&id=2d06c2c7&"
import script from "./announceList.vue?vue&type=script&lang=js&"
export * from "./announceList.vue?vue&type=script&lang=js&"
import style0 from "./announceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d06c2c7')) {
      api.createRecord('2d06c2c7', component.options)
    } else {
      api.reload('2d06c2c7', component.options)
    }
    module.hot.accept("./announceList.vue?vue&type=template&id=2d06c2c7&", function () {
      api.rerender('2d06c2c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/announceList.vue"
export default component.exports